module.exports = __webpack_public_path__ + "media/1alB-x-xup.80b37567.mp3";